import {makeObservable, observable, reaction} from "mobx";
import {LayerEffect} from "./layer-effect";
import {RisikoanalyseStore} from "../stores/risikoanalyse-store-mobx";



export interface GenericLayerEffectProps {
    store: RisikoanalyseStore;
}

/**
 * Applies generic effect to MapImageLayers or FeatureLayers.
 */
export class GenericLayerEffect extends LayerEffect {
    filterType = "generic";

    constructor(props: GenericLayerEffectProps) {
        super(props);
        makeObservable(this, {
            ready: observable
        });
    }

    apply(): void {
        if (!this.store) {
            return;
        }

        if (this.ready) {
            this.doEffect();
            return;
        }
        // wait for the layers and layer views to be ready
        reaction(
            () => this.ready,
            () => {
                this.doEffect();
            }
        );
    }

    private doEffect() {
        if (!this.layers[0] || !this.layerViews[0]) {
            return;
        }

        if (!this.configs) {
            // no effect configuration found for this layer effect
            return;
        }

        const view = this.store.mapStore?.view;
        if (!view) {
            return;
        }

        // apply effects of all configs to their layers
        this.configs.forEach((config: any) => {

            const layers: Array<__esri.FeatureLayer | __esri.MapImageLayer> = [];

            this.layers.forEach((layer: __esri.FeatureLayer | __esri.MapImageLayer) => {
                if (layer.type === "map-image") {
                    layer.allSublayers?.forEach((subLayer: any) => {
                        if (!config.layerIds?.includes(subLayer.id)) {
                            return;
                        }
                        layers.push(layer);
                    });
                } else if (layer.type === "feature") {
                    if (config.layerIds?.includes((layer as __esri.FeatureLayer).layerId)) {
                        layers.push(layer);
                    }
                }
            });

            layers.forEach((layer: __esri.FeatureLayer | __esri.MapImageLayer) => {
                if (config.subtopicId === this.store.appStore.subtopicId) {
                    layer.effect = config.effect as unknown as __esri.Effect;
                } else {
                    return;
                }
            });
        });
    }
}
